import React, { Component } from 'react';
import styles from './direction-button-row.module.scss';
import PropTypes from 'prop-types';
import DirectionButton from './direction-button';
import Tooltip from '../tooltip';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import safeGa from '../../modules/safeGa';

const POINTER_DEFAULT_OFFSET = 30;
const POINTER_HALF_WIDTH = 15;
const TOOLTIP_WIDTH = 370;

class DirectionButtonRow extends Component {
  constructor() {
    super();
    this.state = {
      tooltipPosition: 0,
      tooltipIsVisible: false,
      tooltipContent: '',
      tooltipLink: '',
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleTooltipMouseEvent = this.handleTooltipMouseEvent.bind(this);
    this.timeout = null;
  }

  handleMouseLeave() {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipIsVisible: false });
    }, 500);
  }

  handleTooltipMouseEvent(mouseIsInTooltip) {
    if (mouseIsInTooltip) {
      clearTimeout(this.timeout);
    } else {
      this.handleMouseLeave();
    }
  }

  handleMouseEnter(buttonContent) {
    const { type } = this.props;
    clearTimeout(this.timeout);
    return e => {
      const targetOffsetLeft = e.target.offsetLeft;
      const targetWidth = e.target.getBoundingClientRect().width;
      const rowRightCorner = this.rowRefElement.getBoundingClientRect().width;

      const tooltipPointerPosition =
        targetOffsetLeft + targetWidth / 2 - POINTER_HALF_WIDTH;
      const computedPosition =
        targetOffsetLeft +
        targetWidth / 2 -
        POINTER_DEFAULT_OFFSET -
        POINTER_HALF_WIDTH;
      const position =
        computedPosition + TOOLTIP_WIDTH > rowRightCorner
          ? rowRightCorner - TOOLTIP_WIDTH
          : computedPosition;

      this.setState({
        tooltipPosition: position,
        tooltipPointerPosition,
        tooltipIsVisible: true,
        tooltipContent: buttonContent.tooltipDescription,
        tooltipLink: `/${type}#${buttonContent.id}`,
      });
    };
  }

  renderButtons() {
    const { content, titleCentered, type } = this.props;
    const className = classnames({
      [styles.buttonTitle]: true,
      [styles.centered]: titleCentered,
    });
    return content.map((buttonContent, i) => {
      let linkUrl = `/${type}#${buttonContent.id}`;
      return (
        <div
          key={i}
          className={styles.buttonWrapper}
          onFocus={this.handleMouseEnter(buttonContent)}
          onBlur={this.handleMouseLeave}
          onMouseEnter={this.handleMouseEnter(buttonContent)}
          onMouseLeave={this.handleMouseLeave}
        >
          <Link
            onClick={() => {
              safeGa('send', {
                hitType: 'event',
                eventCategory: this.props.type,
                eventAction: 'click',
                eventLabel: buttonContent.headline,
              });
            }}
            to={linkUrl}
            className={styles.buttonContent}
          >
            <DirectionButton link={linkUrl}>
              <img src={`/contentful/${buttonContent.icon}`} alt="" />
            </DirectionButton>
            <span className={className} tabIndex="-1">
              {buttonContent.headline}
            </span>
          </Link>
        </div>
      );
    });
  }
  render() {
    const {
      tooltipPosition,
      tooltipPointerPosition,
      tooltipIsVisible,
      tooltipContent,
      tooltipLink,
    } = this.state;
    const { theme, addMarginForIframe } = this.props;
    const className = classnames({
      [styles.buttonRow]: true,
      [theme]: true,
      [styles.marginForIframe]: addMarginForIframe,
    });

    return (
      <div
        className={className}
        ref={ref => {
          this.rowRefElement = ref;
        }}
      >
        {this.renderButtons()}
        <div
          style={{
            transform: `translateX(${tooltipPointerPosition}px)`,
            display: tooltipIsVisible ? 'block' : 'none',
          }}
          className={styles.tooltipPointer}
        />
        <Tooltip
          ref={ref => {
            this.tooltipRefElement = ref;
          }}
          position={tooltipPosition}
          isVisible={tooltipIsVisible}
          content={tooltipContent}
          link={tooltipLink}
          mouseIsIn={this.handleTooltipMouseEvent}
        />
      </div>
    );
  }
}

DirectionButtonRow.propTypes = {
  content: PropTypes.array.isRequired,
  color: PropTypes.string,
  type: PropTypes.string.isRequired,
  titleCentered: PropTypes.bool,
  addMarginForIframe: PropTypes.bool,
};
export default DirectionButtonRow;



// WEBPACK FOOTER //
// ./src/components/direction-button-row/direction-button-row.js